import { Widget, EditorTypeRegistry, EditorUtils, Select2Editor, BooleanEditor } from "@serenity-is/corelib";
import { extend, isInstanceOfType, localText } from "@serenity-is/corelib/q";
import { Editor, EditorOptions, Grid, Position, ValidationResult } from "@serenity-is/sleekgrid";
import { GridEditController } from "./GridEditController";

export class GridEditWrapper implements Editor {
    private args: EditorOptions;
    private editor: Widget<any>;
    private defaultValue: any;

    constructor(args: EditorOptions) {
        this.args = args;

        var controller = (args.grid as Grid).getOptions().editorFactory as GridEditController<any>;
        var propertyItem = args.column.editableProperty ?? args.column.sourceItem;

        var editorParams = extend({}, propertyItem.editorParams);
        var ctrlEditorParams = controller?.options?.editorParams;
        if (ctrlEditorParams != null) {
            if (typeof ctrlEditorParams === "function")
                ctrlEditorParams = ctrlEditorParams({ column: args.column, item: args.item, slickArgs: args });
            editorParams = extend(editorParams, ctrlEditorParams);
        }

        var editorType = controller?.options?.editorType?.({
            column: args.column, item: args.item, slickArgs: args
        }) ?? EditorTypeRegistry.get(propertyItem.editorType ?? "String")
        ;

        var createOptions = {
            container: $(args.container),
            element: el => el.addClass('s-cell-editor'),
            type: editorType,
            options: editorParams
        }

        this.editor = Widget.create(createOptions);

        var maxLength = editorParams.maxLength ?? editorParams.maxlength ?? propertyItem?.maxLength;
        if (maxLength != null) {
            if (this.editor.element.is(':input')) {
                if (maxLength > 0) {
                    this.editor.element?.attr('maxlength', maxLength);
                }
                else {
                    this.editor.element?.removeAttr('maxlength');
                }
            }            
        }

        this.editor.element.focus();
        this.editor.element[0]["select"]?.();

        controller?.options?.editorInit?.({
            column: args.column, editor: this.editor, item: args.item, slickArgs: args
        });
    }

    focus(): void {
        this.editor.element.focus();
    }

    isValueChanged(): boolean {
        return JSON.stringify(this.serializeValue()) !=
            JSON.stringify(this.defaultValue);
    }

    keyCaptureList?: number[];

    loadValue(source: any): void {
        const propertyItem = this.args.column.editableProperty ?? this.args.column.sourceItem;
        EditorUtils.loadValue(this.editor, propertyItem, source);
        this.defaultValue = this.serializeValue();
    }

    serializeValue() {
        const propertyItem = this.args.column.editableProperty ?? this.args.column.sourceItem;
        const target = Object.create(null);
        EditorUtils.saveValue(this.editor, propertyItem, target);

        if (propertyItem.name !== this.args.column.name &&
            isInstanceOfType(this.editor, Select2Editor))
            target[this.args.column.field] = (this.editor as Select2Editor<any, any>).text;

        return target;
    }

    applyValue(target: any, state: any): void {
        for (var k of Object.keys(state))
            target[k] = state[k];
    }

    position?(pos: Position): void {
    }

    preClick?(): void {
        if (this.args.column.sourceItem?.editorType == "Boolean")
            (this.editor as BooleanEditor).value = !(this.editor as BooleanEditor).value;
    }

    hide?(): void {
    }

    show?(): void {
    }

    validate?(): ValidationResult {
        const propertyItem = this.args.column.editableProperty ?? this.args.column.sourceItem;
        const value = EditorUtils.getValue(this.editor);
        if (propertyItem.required &&
            (value == null || (typeof value === "string" && !value.trim().length))) {
            return {
                valid: false,
                msg: localText("Validation.Required")
            }
        }

        if (this.args.column.validator != null) {
            var result = this.args.column.validator(value, this.args);
            if (!result.valid)
                return result;
        }

        var controller = (this.args.grid as Grid).getOptions().editorFactory as GridEditController<any>;
        if (controller &&
            controller.options?.validator) {
            var message = controller.options.validator(value, this.args);
            if (message != null)
                return { valid: false, msg: message };
        }

        return { valid: true, msg: null }
    }

    destroy() {
        this.editor?.destroy();
    }
}